import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HrmsLinkComponent } from './hrms-link/hrms-link.component';
import { SubjectDetailsComponent } from './subject-details/subject-details.component';
import { CostcentreDetailsComponent } from './costcentre-details/costcentre-details.component';
import { DeptDesigDetailsComponent } from './dept-desig-details/dept-desig-details.component';
import { HrmsLandingPageComponent } from './hrms-landing-page/hrms-landing-page.component';
import { EmployeeExitDetailsComponent } from './employee-exit-details/employee-exit-details.component';

const routes: Routes = [
  {
    path: '', component: HrmsLinkComponent,
    children: [
      { path: '', redirectTo: 'HrmsReport', pathMatch: 'full' },
      { path: 'HrmsReport', component: HrmsLandingPageComponent },
      { path: 'hrmssubject', component: SubjectDetailsComponent },
      { path: 'costcenter', component: CostcentreDetailsComponent },
      { path: 'deptdesign', component: DeptDesigDetailsComponent },
      { path: 'employeeexit', component: EmployeeExitDetailsComponent }
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HrmsReportsRoutingModule { }
